import * as constActions from './AlertsConstActions';
import initialState from './initialState';
import { severitiesAll, severitiesHighAndCrtitcal } from 'common/Helpers/Alerts/AlertSeverityHelpers';

export default function alertsPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.LOAD_OVERALLALERTS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: action.overallalerts
      });
    case constActions.UPDATE_ALERT_ROWS:
      return Object.assign({}, state, {
        alertsrowsdata: action.alertsrowsdata
      });
    case constActions.POST_ALERT_NEW_STATUS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: state.alertsrowsdata.map((currAlert, index) => {
          if (currAlert.id == action.alert.id) {
            return action.alert;
          }
          return currAlert;
        })
      });
    case constActions.POST_ALERT_REMOVE_NEW_STATUS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: state.alertsrowsdata.filter(currAlert => currAlert.id !== action.alert.id),
        totalOfFetchedAlerts: state.totalOfFetchedAlerts - 1
      });
    case constActions.GET_ALERTS_COUNT_BY_ENTITY:
      return Object.assign({}, state, {
        alertsCountByEntity: action.alertsCountByEntity
      });
    case constActions.GET_ALERTS_COUNT_BY_DATE:
      return Object.assign({}, state, {
        alertsCountByDate: action.alertsCountByDate
      });
    case constActions.POST_SEARCH_ALERTS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: [...state.alertsrowsdata, ...action.alerts.alerts],
        amountOfFetchedAlerts: action.amount,
        totalOfFetchedAlerts: action.alerts.countBySearch
      });
    case constActions.POST_SEARCH_NEW_ALERTS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: [...action.alerts.alerts],
        amountOfFetchedAlerts: action.amount,
        totalOfFetchedAlerts: action.alerts.countBySearch
      });
    case constActions.GET_ALERT_BY_ID_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: [action.alert],
        amountOfFetchedAlerts: 1
      });
    case constActions.GET_COMMENTS_SUCCESS:
      return Object.assign({}, state, {
        comments: Object.assign({}, state.comments, {
          [action.alertId]: action.comments
        })
      });
    case constActions.ADD_COMMENT_SUCCESS:
      if (state.comments[action.comment.AlertId]) {
        return Object.assign({}, state, {
          comments: Object.assign({}, state.comments, {
            [action.comment.AlertId]: [...state.comments[action.comment.AlertId], action.comment]
          })
        });
      } else {
        return Object.assign({}, state, {
          comments: Object.assign({}, state.comments, {
            [action.comment.AlertId]: [action.comment]
          })
        });
      }
    case constActions.ADD_COMMENTS_SUCCESS:
      return Object.assign({}, state, {
        alertsrowsdata: action.alertsrowsdata
      });
    case constActions.GET_USER_NAME_SUCCESS:
      return Object.assign({}, state, {
        userName: action.userName
      });
    case constActions.UPDATE_SELECTED_ALERT_ROWS:
      return Object.assign({}, state, {
        selectedAlertRows: action.selectedAlertRows
      });
    case constActions.SET_SEVERITY_ALL:
      return {
        ...state,
        ...{ selectedSeverities: severitiesAll() }
      };
    case constActions.SET_SEVERITY_HIGH_CRITICAL:
      return {
        ...state,
        ...{ selectedSeverities: severitiesHighAndCrtitcal() }
      };
    case constActions.SET_SEVERITY:
      return {
        ...state,
        ...{ selectedSeverities: { ...action.severity } }
      };
    case constActions.GET_ALERT_PROCESS_TREE_REQUEST: {
      return state;
    }
    case constActions.GET_ALERT_PROCESS_TREE_SUCCESS: {
      let newState = Object.assign({}, state, {
        processTree: Object.assign({}, state.processTree, {
          [action.alertId]: action.alertProcessTree
        })
      });

      return newState;
    }
    case constActions.GET_ALERT_PROCESS_TREE_FAILURE: {
      return state;
    }
    case constActions.SET_SITES_PER_USER:
      return Object.assign({}, state, {
        sitesPerUser: action.data
      });
    default:
      return state;
  }
}
